module.exports = __webpack_public_path__ + "img/logo_jsm.ae66febd.png";